export const LOG_LEVELS = ['trace', 'debug', 'info', 'warn', 'error', 'fatal', 'unknown'] as const;

export type LogLevel = (typeof LOG_LEVELS)[number];

export type LogEntry = {
  timestamp: string;
  level: LogLevel;
  pod: string;
  container: string;
  message: string;
  details: Record<string, unknown> | null;
};

export type LogQuery = {
  start: string;
  end: string;
  level?: LogLevel;
  pod?: string;
  search?: string;
};

export type LogQueryResult = {
  entries: LogEntry[];
  pods: string[];
  source: 'fixture' | 'loki';
  queriedAt: string;
};
